import { DateTime } from 'luxon';
import { AnalyticsByDay, Period, TimeSignalUtilization } from 'graphql/types';
export const colorSet = new Map<string, string>([
  ['Meeting', '#2196f3'],
  ['Scheduling', '#e02e74'],
  ['Messaging', '#4caf50'],
  ['Email', '#ffeb3b'],
  ['Software Development', '#a60acc'],
  ['Project Management', '#230acc'],
  ['Design', '#0accb7'],
  ['IT Service Management', '#cbcc0a'],
  ['Browser', '#c66f08']
]);

const defaultColor = '#607d8b';

export type dataType = {
  name: string;
  color: string;
  data: AnalyticsByDay[];
};
export function getDaterange(
  currentPeriod: Period | null,
  checked: boolean,
  data: TimeSignalUtilization[]
): Set<string> {
  let dateSet = new Set<string>();
  if (!checked) {
    let startDate = DateTime.fromISO(currentPeriod?.startDate);
    const endDate = DateTime.fromISO(currentPeriod?.endDate);

    while (startDate <= endDate) {
      dateSet.add(startDate.toISODate());
      startDate = startDate.plus({ days: 1 });
    }
  } else {
    let dates: string[] = [];
    data.forEach((v) => {
      dates = [...dates, ...v.data.map((x) => x.date)];
    });
    dateSet = new Set(dates);
  }
  return dateSet;
}
export function transformUtilzationAnalyticsData(
  data: TimeSignalUtilization[],
  checked: boolean,
  currentPeriod: Period | null
): dataType[] {
  let dateSet: Set<string>;
  dateSet = getDaterange(currentPeriod, checked, data);

  const transformedData = data.map((d) => {
    if (checked) {
      dateSet = getDaterange(currentPeriod, checked, data);
    }
    const color = colorSet.get(d.categoryName) || defaultColor;

    const existingData = [...d.data];
    const presentDates = d.data.map((x) => x.date);
    dateSet.forEach((z) => {
      if (!presentDates.includes(z)) {
        existingData.push({
          date: z,
          totalCount: 0,
          totalDuration: 0
        });
      }
    });
    existingData.sort((a, b) => {
      if (a.date < b.date) {
        return -1;
      }
      if (a.date > b.date) {
        return 1;
      }
      return 0;
    });

    return {
      name: d.categoryName,
      color: color,
      data: existingData
    };
  });

  transformedData.sort((a, b) => a.name.localeCompare(b.name));

  return transformedData;
}
